module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-summer-3200.110cb6ea.svg";